import { useQuery as useQuery$1 } from '@apollo/client/react/hooks';

const useQuery = useQuery$1;

export { useQuery };
